import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetRequest,
  PostRequest,
  PutRequest,
  DeleteRequest,
  PostRequestImportExcel,
} from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "./Companies.css";

Modal.setAppElement("#root");

export default function HazardManagement() {
  const [hazards, setHazards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [importByCompanyModalIsOpen, setImportByCompanyModalIsOpen] =
    useState(false);
  const [importModalIsOpen, setImportModalIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    company_type_id: "",
  });
  const [deleteId, setDeleteId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchHazards();
    fetchCompanies();
    fetchCompanyTypes();
  }, []);

  const fetchHazards = () => {
    setLoading(true);
    GetRequest("/risk_categories")
      .then((response) => {
        setHazards(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch hazards", error);
        setLoading(false);
      });
  };

  const fetchCompanies = () => {
    setLoading(true);
    GetRequest("/companies")
      .then((response) => {
        setCompanies(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch companies", error);
      });
  };

  const fetchCompanyTypes = () => {
    setLoading(true);
    GetRequest("/company_type")
      .then((response) => {
        setCompanyTypes(response.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch company types", error);
      });
  };

  const openEditModal = (hazard = null) => {
    if (hazard) {
      setFormData({
        id: hazard.id,
        name: hazard.name,
        company_type_id: hazard.company_type_id,
      });
      setIsEditMode(true);
    } else {
      setFormData({
        id: "",
        name: "",
        company_type_id: "",
      });
      setIsEditMode(false);
    }
    setModalIsOpen(true);
  };

  const closeEditModal = () => {
    setModalIsOpen(false);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setDeleteId(null);
  };

  const openImportByCompanyModal = () => {
    setImportByCompanyModalIsOpen(true);
  };

  const closeImportByCompanyModal = () => {
    setImportByCompanyModalIsOpen(false);
  };

  const openImportModal = () => {
    setImportModalIsOpen(true);
  };

  const closeImportModal = () => {
    setImportModalIsOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const request = isEditMode
      ? PutRequest(formData, `/risk_categories/${formData.id}`)
      : PostRequest(formData, "/risk_categories");

    request
      .then(() => {
        fetchHazards();
        closeEditModal();
      })
      .catch((error) => {
        console.error("Failed to submit form", error);
      });
  };

  const handleDelete = () => {
    DeleteRequest(`/risk_categories/${deleteId}`)
      .then(() => {
        fetchHazards();
        closeDeleteModal();
      })
      .catch((error) => {
        console.error("Failed to delete hazard", error);
        closeDeleteModal();
      });
  };

  const handleImport = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    PostRequestImportExcel(formData, "/import")
      .then(() => {
        fetchHazards();
        closeImportModal();
      })
      .catch((error) => {
        console.error("Failed to import hazards", error);
      });
  };

  const handleImportByCompany = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    console.log(formData);
    const file = formData.get("file");
    const companyTypeId = formData.get("company_type_id");

    console.log(file);
    console.log(companyTypeId);
    PostRequestImportExcel(formData, "/importbycompany")
      .then(() => {
        fetchHazards();
        closeImportByCompanyModal();
      })
      .catch((error) => {
        console.error("Failed to import hazards by company", error);
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  const handleCompanyChange = (e) => {
    const companyId = e.target.value;
    setSelectedCompany(companyId);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <button className="btn-add" onClick={openImportByCompanyModal}>
          <FontAwesomeIcon icon={faPlus} /> Import By Company
        </button>
        <button
          style={{ marginLeft: "10px" }}
          className="btn-add"
          onClick={openImportModal}
        >
          <FontAwesomeIcon icon={faPlus} /> Import
        </button>
      </div>
      {loading ? (
        <p style={{ textAlign: "center" }}>Wird geladen...</p>
      ) : (
        <div className="card-admin animated fadeInDown">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Erstellungsdatum</th>
                <th>Bearbeitungsdatum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {hazards.map((hazard) => (
                <tr key={hazard.id}>
                  <td>{hazard.id}</td>
                  <td>{hazard.name}</td>
                  <td>{formatDate(hazard.created_at)}</td>
                  <td>{formatDate(hazard.updated_at)}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openEditModal(hazard)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    &nbsp;
                    <button
                      className="btn-delete"
                      onClick={() => openDeleteModal(hazard.id)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeEditModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>{isEditMode ? "Update Risk Category" : "Add Risk Category"}</h5>
        <form onSubmit={handleFormSubmit} className="modal-form">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <input
              type="hidden"
              name="company_type_id"
              value={formData.company_type_id}
              onChange={handleInputChange}
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-submit">
              {isEditMode ? "Update" : "Add"}
            </button>
            <button
              type="button"
              className="btn-cancel"
              onClick={closeEditModal}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Are you sure you want to delete this risk category?</h5>
        <div className="modal-actions">
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
          <button className="btn-cancel" onClick={closeDeleteModal}>
            Cancel
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={importByCompanyModalIsOpen}
        onRequestClose={closeImportByCompanyModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Import By Company</h5>
        <form onSubmit={handleImportByCompany} className="modal-form">
          <div className="form-group">
            <label>Company:</label>
            <select
              name="company_id"
              required
              className="form-control"
              onChange={handleCompanyChange}
            >
              <option value="">Select Company</option>
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Company Type:</label>
            <select name="company_type_id" required className="form-control">
              <option value="">Select Company Type</option>
              {companyTypes
                .filter((type) => type.company_id === selectedCompany)
                .map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="form-group">
            <label>File:</label>
            <input
              type="file"
              name="file"
              accept=".xls,.xlsx"
              className="form-control"
              required
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-submit">
              Import
            </button>
            <button
              type="button"
              className="btn-cancel"
              onClick={closeImportByCompanyModal}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={importModalIsOpen}
        onRequestClose={closeImportModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Import</h5>
        <form onSubmit={handleImport} className="modal-form">
          <div className="form-group">
            <label>Company Type:</label>
            <select name="company_type_id" required className="form-control">
              <option value="">Select Company Type</option>
              {companyTypes
                .filter((type) => type.company_id === null)
                .map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="form-group">
            <label>File:</label>
            <input
              type="file"
              name="file"
              accept=".xls,.xlsx"
              className="form-control"
              required
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-submit">
              Import
            </button>
            <button
              type="button"
              className="btn-cancel"
              onClick={closeImportModal}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
